import React, { useCallback, useState, useEffect } from "react";
import { Form, Select, Button, Input, DatePicker } from "antd";
import styled from "styled-components";
import { debounce } from "lodash";
import { lookUp } from "../../api/LookUpAPI";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

const StyledForm = styled(Form)`
  width: 100%;
  margin-bottom: 24px;
`;

const FilterInputs = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 16px;
  width: 100%;
`;

const FilterActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 16px;
`;

const StyledRangePicker = styled(RangePicker)`
  background: white;
  width: 100%;
  > .ant-picker-input .ant-picker-clear:hover {
    color: unset !important;
  }
`;

const ListFilter = ({ onFilter, clearFilter }) => {
  const [form] = Form.useForm();

  const [fetchTelemedicine, setFetchTelemedicine] = useState();
  const [fetchClients, setFetchClients] = useState();

  const onSearch = () => {
    const data = form.getFieldsValue();
    const filter = {};
    filter["telemedicine-category"] = data.telemedicinecategory;
    filter["client-id"] = data.clients;
    filter["physician-id"] = data.physicianid;
    filter["start-date"] = data.createddate && dayjs(data.createddate[0]).format("MM-DD-YYYY");
    filter["end-date"] = data.createddate && dayjs(data.createddate[1]).format("MM-DD-YYYY");
    onFilter(filter);
  };

  // eslint-disable-next-line
  const debounceId = useCallback(debounce(onSearch, 3000), []);

  const onClearFilter = () => {
    form.resetFields();
    clearFilter();
  };

  useEffect(() => {
    const responsetelemedicine = [];
    const responseClient = [];
    lookUp("tele-medicine-category").then((res) => {
      res.data.payload.map((state) => {
        return responsetelemedicine.push({
          key: state._id,
          value: state.name,
          text: state.name,
        });
      });
      setFetchTelemedicine(responsetelemedicine);
    });

    lookUp("client").then((res) => {
      res.data.payload.map((state) => {
        return responseClient.push({
          key: state._id,
          value: state.name,
          text: state.name,
        });
      });
      setFetchClients(responseClient);
    });
  }, []);

  return (
    <StyledForm form={form} name="physician_details" layout="vertical">
      <FilterInputs>
        <Form.Item name="physicianid" label="Physician Id" style={{ flex: 1, marginBottom: 0 }}>
          <Input
            placeholder="Filter by Physician Id"
            getPopupContainer={(trigger) => trigger.parentElement}
            onChange={debounceId}
          />
        </Form.Item>

        <Form.Item name="telemedicinecategory" label="Category" style={{ flex: 1, marginBottom: 0 }}>
          <Select allowClear placeholder="Filter by telemedicine category" getPopupContainer={(trigger) => trigger.parentElement}>
            {fetchTelemedicine &&
              fetchTelemedicine.map((eachCategory) => (
                <Select.Option key={eachCategory.key} value={eachCategory.key}>
                  {eachCategory.value}
                </Select.Option>
              ))}
          </Select>
        </Form.Item>

        <Form.Item name="clients" label="Clients" style={{ flex: 1, marginBottom: 0 }}>
          <Select allowClear placeholder="Filter by Clients" getPopupContainer={(trigger) => trigger.parentElement}>
            {fetchClients &&
              fetchClients.map((eachClient) => (
                <Select.Option key={eachClient.key} value={eachClient.key}>
                  {eachClient.value}
                </Select.Option>
              ))}
          </Select>
        </Form.Item>

        <Form.Item name="createddate" label="Created Date Range" style={{ flex: 1.5, marginBottom: 0 }}>
          <StyledRangePicker getPopupContainer={(trigger) => trigger.parentElement} />
        </Form.Item>
      </FilterInputs>

      <FilterActions>
        <Form.Item style={{ marginBottom: 0 }}>
          <Button type="default" onClick={() => onClearFilter()}>
            Clear
          </Button>
        </Form.Item>
        <Form.Item style={{ marginBottom: 0 }}>
          <Button type="primary" onClick={onSearch}>
            Search
          </Button>
        </Form.Item>
      </FilterActions>
    </StyledForm>
  );
};

export default ListFilter;
